import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog wise-modal" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { for: "AccountName" }
const _hoisted_9 = ["placeholder", "disabled"]
const _hoisted_10 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_11 = { class: "col-md-6 form-group" }
const _hoisted_12 = { for: "AccountType" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { for: "AccountEmail" }
const _hoisted_16 = ["placeholder", "disabled"]
const _hoisted_17 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_18 = { for: "AccountPassword" }
const _hoisted_19 = ["placeholder", "disabled"]
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { for: "AccountServer" }
const _hoisted_22 = ["placeholder", "disabled"]
const _hoisted_23 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_24 = { for: "AccountPort" }
const _hoisted_25 = ["placeholder", "disabled"]
const _hoisted_26 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_27 = { for: "EmailSentAs" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = { class: "d-flex justify-content-end" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.windowTitle), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.emailRecord.AccountName.$error}])
                }, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.language.acct_name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "AccountName",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emailRecord.AccountName) = $event)),
                    placeholder: '(' + _ctx.language.acct_name.toLowerCase() + ')',
                    disabled: _ctx.emailRecord.IdEmail != 0,
                    maxlength: "50",
                    autocomplete: "off",
                    autofocus: "",
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_9), [
                    [_vModelText, _ctx.emailRecord.AccountName]
                  ]),
                  (_ctx.v$.emailRecord.AccountName.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.v$.emailRecord.AccountName.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.acct_type), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "AccountType",
                    name: "AccountType",
                    class: "form-control-sel",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailRecord.AccountType) = $event)),
                    disabled: _ctx.emailRecord.IdEmail != 0
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acctTypes, (actT) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: actT.id,
                        value: actT.id
                      }, _toDisplayString(actT.label), 9, _hoisted_14))
                    }), 128))
                  ], 8, _hoisted_13), [
                    [_vModelSelect, _ctx.emailRecord.AccountType]
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.emailRecord.AccountEmail.$error}])
                }, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.language.acct_email), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "AccountEmail",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailRecord.AccountEmail) = $event)),
                    placeholder: '(' + _ctx.language.acct_email.toLowerCase() + ')',
                    disabled: _ctx.emailRecord.IdEmail != 0,
                    autocomplete: "off",
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_16), [
                    [_vModelText, _ctx.emailRecord.AccountEmail]
                  ]),
                  (_ctx.v$.emailRecord.AccountEmail.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.v$.emailRecord.AccountEmail.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.emailRecord.AccountPassword.$error}])
                }, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.acct_password), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    id: "AccountPassword",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailRecord.AccountPassword) = $event)),
                    placeholder: '(' + _ctx.language.acct_password.toLowerCase() + ')',
                    disabled: _ctx.emailRecord.IdEmail != 0,
                    maxlength: "50",
                    autocomplete: "off",
                    onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_19), [
                    [_vModelText, _ctx.emailRecord.AccountPassword]
                  ]),
                  (_ctx.v$.emailRecord.AccountPassword.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.emailRecord.AccountPassword.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.emailRecord.AccountServer.$error}])
                }, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.acct_server), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "AccountServer",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.emailRecord.AccountServer) = $event)),
                    placeholder: '(' + _ctx.language.acct_server.toLowerCase() + ')',
                    disabled: _ctx.emailRecord.IdEmail != 0,
                    maxlength: "50",
                    autocomplete: "off",
                    onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_22), [
                    [_vModelText, _ctx.emailRecord.AccountServer]
                  ]),
                  (_ctx.v$.emailRecord.AccountServer.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.v$.emailRecord.AccountServer.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.emailRecord.AccountPort.$error}])
                }, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.language.acct_port), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "AccountPort",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.emailRecord.AccountPort) = $event)),
                    placeholder: '(' + _ctx.language.acct_port.toLowerCase() + ')',
                    disabled: _ctx.emailRecord.IdEmail != 0,
                    maxlength: "3",
                    minlength: "3",
                    onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
                    autocomplete: "off",
                    onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_25), [
                    [_vModelText, _ctx.emailRecord.AccountPort]
                  ]),
                  (_ctx.v$.emailRecord.AccountPort.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.v$.emailRecord.AccountPort.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-group", {'has-error': _ctx.v$.emailRecord.EmailSentAs.$error}])
                }, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.language.email_sent_as), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "EmailSentAs",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.emailRecord.EmailSentAs) = $event)),
                    placeholder: '(' + _ctx.language.email_sent_as.toLowerCase() + ')',
                    maxlength: "150",
                    autocomplete: "off",
                    onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_28), [
                    [_vModelText, _ctx.emailRecord.EmailSentAs]
                  ]),
                  (_ctx.v$.emailRecord.EmailSentAs.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.v$.emailRecord.EmailSentAs.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary me-2",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args)))
                }, _toDisplayString(_ctx.language.close), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] }),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_32)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}